import { render, staticRenderFns } from "./JsonViewer.vue?vue&type=template&id=8449b914&scoped=true&"
import script from "./JsonViewer.vue?vue&type=script&lang=ts&"
export * from "./JsonViewer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8449b914",
  null
  
)

export default component.exports